import React, { useState, useEffect } from "react";
import { useLang } from "../context/LanguageContext";

const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("pi_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handle = (value) => {
    localStorage.setItem("pi_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-md rounded-xl border border-neutral-200 bg-white p-5 shadow-2xl animate-in">
      <h4 className="text-base font-semibold text-neutral-900">{t.cookie.title}</h4>
      <p className="mt-2 text-sm leading-relaxed text-neutral-600">{t.cookie.text}</p>
      <div className="mt-4 flex gap-3">
        <button
          onClick={() => handle("rejected")}
          className="flex-1 rounded-md border border-neutral-300 py-2 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50"
        >
          {t.cookie.reject}
        </button>
        <button
          onClick={() => handle("accepted")}
          className="flex-1 rounded-md bg-[#F26522] py-2 text-sm font-semibold text-white transition-colors hover:bg-[#d9561a]"
        >
          {t.cookie.accept}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
